import Contact from "../components/Contact";
import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
import ParticlesBackground from "../components/ParticlesBackground";
import GraphicDesignCarousel from "../components/Projects/GraphicDesignCarousel";
import LongFormVideos from "../components/Projects/LongFormVideos";
import VideoCarousel from "../components/Projects/VideoCarousel";

const Projects = () => {
  return (
    <div className="text-white flex flex-col gap-y-10 font-inter">
      <div className="px-8 font-inter text-white xl:px-20 2xl:px-60 flex flex-col">
        <NavBar />
        <GraphicDesignCarousel />
        <div className="-z-10">
          <ParticlesBackground id="particles" />
        </div>
        <VideoCarousel />
        <LongFormVideos />
      </div>
      <Contact />
      <Footer link="Projects" />
    </div>
  );
};

export default Projects;
